import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import { i18n, loadLanguageAsync } from '@/i18n-setup.js';
import { LocaleService } from './services/locale';

loadLanguageAsync(LocaleService.getLocale());

new Vue({
    router,
    i18n,
    render: h => h(App),
}).$mount('#app');
